import { render, staticRenderFns } from "./TrainingPlanItemDescriptionPlaceholder.vue?vue&type=template&id=38ede398&"
import script from "./TrainingPlanItemDescriptionPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemDescriptionPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports